// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".b80b4081559ed1f06712bfc2e7ecca0bc24f44a4.chunk.js";
};